import { writable } from 'svelte/store';
// import type {UserData} from "./Types"
// export const users: Writable<UserData[]> = writable([]);
export const overlay = writable(null);
export const modal = writable(null);
